import Button from '@components/v2/ui/Button/Button';
import Icon from '@components/v2/ui/Icon/Icon';
import { Box, CircularProgress } from '@mui/material';
import { ReactNode } from 'react';
import LangEnum from '../../../../../../lang/LangEnum';
import { useTranslation } from '../../../../../../modules/translation/TranslationContext';
import { ScreenHeaderPrimaryAction } from '../../screenHeader.types';

const PHONE_PRIMARY_ACTION_MAX_WIDTH = 160;

const renderPrimaryActionIcon = (primaryAction: ScreenHeaderPrimaryAction) => {
  if (!primaryAction.icon || primaryAction.isLoading) {
    return undefined;
  }
  return <Icon icon={primaryAction.icon} size="md" />;
};

const getPrimaryButtonVariantProps = (variant: ScreenHeaderPrimaryAction['variant']) =>
  variant === 'text'
    ? ({ variant: 'text', color: 'secondary' } as const)
    : ({ variant: 'contained', color: 'primary' } as const);

interface ScreenHeaderActionsProps {
  actions?: ReactNode;
  primaryAction?: ScreenHeaderPrimaryAction;
  isPhone?: boolean;
}

export const ScreenHeaderActions = ({
  actions,
  primaryAction,
  isPhone,
}: ScreenHeaderActionsProps) => {
  const { translate } = useTranslation();

  const primaryButton =
    primaryAction && !primaryAction.isHidden ? (
      <Button
        {...getPrimaryButtonVariantProps(primaryAction.variant)}
        size="medium"
        disabled={primaryAction.isLoading || primaryAction.isDisabled}
        testId={primaryAction.testId}
        onClick={primaryAction.onClick}
        sx={{ maxWidth: isPhone ? PHONE_PRIMARY_ACTION_MAX_WIDTH : undefined, minWidth: 0 }}
        startIcon={renderPrimaryActionIcon(primaryAction)}
      >
        {primaryAction.isLoading ? (
          <CircularProgress size={16} color="inherit" />
        ) : (
          <Box
            component="span"
            sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
          >
            {translate(primaryAction.label as LangEnum)}
          </Box>
        )}
      </Button>
    ) : null;

  return (
    <>
      {actions}
      {primaryButton}
    </>
  );
};
